<template>
    <v-form v-model="form_validation">
        <v-text-field
            id="sum"
            v-model="sum"
            :label="'Sum (EUR)' | t"
            :rules="[v => !!v || this.t('Sum is required')]"
            placeholder="18.32"
            prepend-icon="euro_symbol"
            type="number"
            @keypress="onlyIntegersWithComa"
        />
        <v-text-field
            id="description"
            v-model="description"
            :label="'Description' | t"
            :placeholder="this.t('Invoice') + ' nr 12221'"
            counter="140"
            :rules="descriptionRules"
            prepend-icon="description"
        />
        <v-text-field
            id="ref_nr"
            v-model="ref_nr"
            :label="'Reference number' | t"
            counter="19"
            placeholder="18002938120"
            :rules="referenceNumberRules"
            prepend-icon="arrow_forward"
            type="number"
            @keypress="onlyIntegers"
        />
        <v-select
            id="frequency"
            v-model="frequency"
            :items="frequencyItems"
            :label="'Frequency' | t"
            :placeholder="'Monthly' | t"
            prepend-icon="alarm_add"
            :rules="[v => !!v || this.t('Frequency is required')]"
        />

        <vc-date-picker
            v-model="start_date"
            :min-date="start_min_date || new Date()"
            :popover="{ placement: 'bottom', visibility: 'click' }"
            :disabled-dates="{ weekdays: [1, 7] }"
            color="gray"
            is-expanded
        >
            <template v-slot="{ inputValue, inputEvents }">
                <v-text-field
                    id="star_date"
                    v-on="inputEvents"
                    :label="'Start date' | t"
                    :value="inputValue"
                    placeholder="01.01.2020"
                    prepend-icon="calendar_today"
                    :disabled="!frequency"
                />
            </template>
        </vc-date-picker>

        <vc-date-picker
            v-model="end_date"
            :min-date="end_min_date || new Date()"
            :popover="{ placement: 'bottom', visibility: 'click' }"
            :disabled-dates="{ weekdays: [1, 7] }"
            color="gray"
            is-expanded
        >
            <template v-slot="{ inputValue, inputEvents }">
                <v-text-field
                    id="star_date"
                    v-on="inputEvents"
                    :label="'End date' | t"
                    :value="inputValue"
                    placeholder="31.12.2020"
                    prepend-icon="calendar_today"
                    :disabled="!start_date"
                />
            </template>
        </vc-date-picker>

        <v-btn
            id="createPayment"
            :disabled="!form_validation || !end_date || !start_date"
            class="mt-2"
            @click="addProductToDb"
            >{{ "Create" | t }}
        </v-btn>
    </v-form>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import moment from "moment";
import { paymentMixin } from "@/mixins/payment-mixin";

export default {
    name: "create-periodic-payment",
    mixins: [paymentMixin],
    data() {
        return {
            frequency: null,
            frequencyItems: ["Daily", "Weekly", "Monthly"],
            start_date: null,
            start_min_date: null,
            end_min_date: null,
            end_date: null
        };
    },
    mounted() {
        this.start_min_date = moment()
            .add(1, "days")
            .toDate();
    },
    watch: {
        start_date: function(value) {
            this.end_date = null;
            if (!this.frequency) {
                this.end_min_date = moment(value)
                    .add(1, "days")
                    .toDate();
            } else if (this.frequency === "Weekly") {
                this.end_min_date = moment(value)
                    .add(8, "days")
                    .toDate();
            } else if (this.frequency === "Monthly") {
                this.end_min_date = moment(value)
                    .add(1, "days")
                    .add(1, "months")
                    .toDate();
            } else if (this.frequency === "Quarterly") {
                this.end_min_date = moment(value)
                    .add(1, "days")
                    .add(3, "months")
                    .toDate();
            } else if (this.frequency === "Semi Annually") {
                this.end_min_date = moment(value)
                    .add(1, "days")
                    .add(6, "months")
                    .toDate();
            } else if (this.frequency === "Annually") {
                this.end_min_date = moment(value)
                    .add(1, "days")
                    .add(1, "years")
                    .toDate();
            }
        },
        frequency: function() {
            if (this.start_date) this.start_date = null;
        }
    },
    methods: {
        ...mapMutations(["setRequestError", "setErrorMessage"]),
        ...mapActions(["addProduct"]),
        async addProductToDb() {
            if (moment(this.start_date) >= moment(this.end_date)) {
                this.setRequestError(true);
                this.setErrorMessage("Problem with dates.");
            } else {
                let payload = {
                    sum: this.sum,
                    desc: this.description,
                    ref_nr: this.ref_nr,
                    type: "periodic",
                    start_date: moment(this.start_date).format("YYYY-MM-DD"),
                    end_date: moment(this.end_date).format("YYYY-MM-DD"),
                    frequency: this.frequency
                };
                await this.addProduct(payload);
            }
        }
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
